import React, { Component } from 'react'
import { Button, ButtonIcon } from 'rmwc/Button';
import { Grid, GridCell } from 'rmwc/Grid';
import { FormField } from 'rmwc/FormField';
import { Card } from 'rmwc/Card';
import { TextField, TextFieldIcon } from 'rmwc/TextField';
import { Typography } from 'rmwc/Typography';
import { Select } from 'rmwc/Select';
import {default as Reactsel} from "react-select";
import { Link } from 'react-router-dom';
import SerializeForm from 'form-serialize'
import * as api from '../../api/api'
import {stateToHTML} from 'draft-js-export-html';
import { EditorState, ContentState, convertFromHTML } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import {Editor as DiffEditor} from 'draft-js';
import StatusMessage from '../../util/StatusMessage'
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

class OpportunityForm extends Component {
	state = {
		errorMsg: {

		},
		opportunityTypes: [],
		opportunityCategories: [],
		data: {
			organization: '',
			position: '',
			location: '',
			cutOffDate: '',
			salary: '',
			status: '',
			jobDescription: EditorState.createEmpty(),
			opportunityId: '',
			opportunityTypeId: '',
			selectedCategories:[],
			websiteLink:'',
			orgImgLink: '',
			postApplyMsg: '',
			listingSequence: '',
			emailTemplateId: '',
		},

		formErrors:{
			organizationError: '',
			positionError: '',
			locationError: '',
			cutOffDateError: '',
			salaryError: '',
			statusError: '',
			jobDescriptionError: '',
			opportunityTypeIdError: '',
			selectedCategoriesError: '',
			orgImgLinkError: '',
			postApplyMsgError: '',
			listingSequenceError: '',
		}
	}

	onInputChange = evt => {
    const data = Object.assign({}, this.state.data);
    data[evt.target.name] = evt.target.value;
    this.setState({data});
  };

	componentDidMount(){
	var curr = this;
    let data = Object.assign({}, this.state.data);
    let opportunityTypesList
    let opportunityCategories
    if (this.props.oppertunityId) {
    	api.getOpportunityCategories(this.props.userToken)
        .then((result) =>{
          	opportunityCategories = result.data
    		return api.getOpportunityTypes(this.props.userToken)
    	})
        .then((result) =>{
          opportunityTypesList = result
      	  return api.getOpportunity(this.props.userToken, this.props.oppertunityId)
      }).then(function(result){
	      if (result) {
		      data.organization = result.data.opportunity.organization? result.data.opportunity.organization: '';
		      data.position = result.data.opportunity.position?result.data.opportunity.position : '';
		      data.location = result.data.opportunity.location ?result.data.opportunity.location: '';
		      data.cutOffDate = result.data.opportunity.cutOffDate ? result.data.opportunity.cutOffDate: '';
		      data.salary = result.data.opportunity.salary ? result.data.opportunity.salary : '';
		      data.status = result.data.opportunity.status ? result.data.opportunity.status : '';
		      //data.jobDescription = result.data.opportunity.jobDescription? result.data.opportunity.jobDescription : '';
		      if (result.data.opportunity.jobDescription !== '') {
			      let contentValue = convertFromHTML(result.data.opportunity.jobDescription)
			      const contentState = ContentState.createFromBlockArray(contentValue);
			      data.jobDescription = EditorState.createWithContent(contentState)
			  }
		      data.opportunityId = result.data.opportunity.id? result.data.opportunity.id : '';
		      data.opportunityTypeId = result.data.opportunity.opportunityTypeId? result.data.opportunity.opportunityTypeId : '';
		      data.selectedCategories = result.data.categories? result.data.categories : '';
		      data.websiteLink = result.data.opportunity.websiteLink? result.data.opportunity.websiteLink : '';
		      data.orgImgLink = result.data.opportunity.orgImgLink? result.data.opportunity.orgImgLink : '';
		      data.listingSequence = result.data.opportunity.listingSequence? result.data.opportunity.listingSequence : '';
		      data.postApplyMsg = result.data.opportunity.postApplyMsg? result.data.opportunity.postApplyMsg : '';
		      data.emailTemplateId = result.data.opportunity.emailTemplateId? result.data.opportunity.emailTemplateId : '';
		    }
		  	curr.setState({data: data, opportunityTypes:opportunityTypesList, opportunityCategories:opportunityCategories})
      })
    }
    else{
    	
    	api.getOpportunityCategories(this.props.userToken)
        .then((result) =>{
          opportunityCategories = result.data
		    return	api.getOpportunityTypes(this.props.userToken)
        }).then((result) =>{
          opportunityTypesList = result
          this.setState({opportunityTypes: opportunityTypesList, opportunityCategories:opportunityCategories})
      })
    }
  }

  handleOpportunityTypeChange = (event) =>{
    
    let data = Object.assign({}, this.state.data)
    if(!event.target.value){
      data.opportunityTypeId = ''
    }else{
    	data.opportunityTypeId = event.target.value
    	
    }
    this.setState({data: data})
  }

  	handleEditorDescriptionUpdate: Function = (editorState) => {
	    let data = Object.assign({}, this.state.data)
	    data.jobDescription = editorState
	    this.setState({data: data});
	};


  handleChangeCategory = (option) => {
  		
      let data = Object.assign({}, this.state.data);
      data.selectedCategories = option
      this.setState({data: data})
    }


  isValidateSuccess = () => {

  	let success = true
    let errorObj = Object.assign({}, this.state.formErrors)
    let data = Object.assign({}, this.state.data)


     errorObj.organizationError = ''
     errorObj.positionError = ''
     errorObj.locationError = ''
     errorObj.cutOffDateError = ''
     errorObj.salaryError = ''
     errorObj.statusError = ''
     errorObj.jobDescriptionError = ''
     errorObj.opportunityTypeIdError = ''
     errorObj.selectedCategoriesError = ''
     errorObj.orgImgLinkError = ''
     errorObj.listingSequenceError = ''
     
     let htmlText = stateToHTML(this.state.data.jobDescription.getCurrentContent())

    if(data.organization === ''){
	    errorObj.organizationError ='organization is mandatory'
	    success = false
    }

    if(data.position === ''){
	    errorObj.positionError ='position is mandatory'
	    success = false
    }

    if(data.location === ''){
	    errorObj.locationError ='location is mandatory'
	    success = false
    }

    if(data.cutOffDate === ''){
	    errorObj.cutOffDateError ='cutOffDate is mandatory'
	    success = false
    }

    if(data.salary === ''){
	    errorObj.salaryError ='salary is mandatory'
	    success = false
    }

    if(data.status === ''){
	    errorObj.statusError ='Status is mandatory'
	    success = false
    }

    if(htmlText.length < 12){
	    errorObj.jobDescriptionError ='Job Description is mandatory and should have atleast 5 characters'
	    success = false
    }

    if(data.opportunityTypeId === ''){
	    errorObj.opportunityTypeIdError ='opportunity Type is mandatory'
	    success = false
    }

    
    if(data.selectedCategories.length < 1){
	    errorObj.selectedCategoriesError ='Categories is mandatory'
	    success = false
    }

    

    if(data.orgImgLink === ''){
	    errorObj.orgImgLinkError ='Logo / Organization Image link is mandatory'
	    success = false
    }

    if(data.listingSequence === ''){
	    errorObj.listingSequenceError ='Custom listing Sequence is mandatory'
	    success = false
    }

    this.setState({
        formErrors:errorObj,
        errorMsg:'',
      })

    return success
  }


  oppFormSubmit = (e) => {
  	e.preventDefault()
  	const formData = SerializeForm(e.target, { hash: true })
  	let htmlText = stateToHTML(this.state.data.jobDescription.getCurrentContent())
  	formData["jobDescription"] = htmlText
  	if (!('emailTemplateId' in formData)){
  		formData["emailTemplateId"] = ''
  	}
  	
  	if(this.isValidateSuccess()){
  		this.props.onFormSubmit(formData)
  	}
  }

	render() {
		return (
			<Grid>
        <GridCell span="12">
        	<form onSubmit={this.oppFormSubmit} style={{width: '100%'}}>
        		<Card style={{padding: '25px'}}>
        			<Typography use="headline5">Create Opportunity</Typography>
        			<Grid className="opportunity-list-item">
	        			<GridCell span="6">
	                <FormField className="opportunity-form-field">
	                  <TextField 
	                  	fullwidth 
	                  	label="Organization" 
	                  	autoComplete="off" 
	                  	name="organization" 
	                  	className='text_input' 
	                  	value={this.state.data.organization}
	                  	onChange={this.onInputChange}
	                  />
	                </FormField>
	                <FormField className="opportunity-form-field">
	                  <TextField 
	                  	fullwidth 
	                  	label="Location" 
	                  	autoComplete="off" 
	                  	name="location" 
	                  	className='text_input' 
	                  	value={this.state.data.location} 
	                  	onChange={this.onInputChange}
	                  />
	                </FormField>
	                <FormField className="opportunity-form-field">
	                  <TextField 
	                  	fullwidth 
	                  	label="Salary(INR)(avg. monthly)" 
	                  	autoComplete="off" 
	                  	name="salary" 
	                  	className='text_input' 
	                  	value={this.state.data.salary} 
	                  	onChange={this.onInputChange}
	                  />
	                </FormField>
	              </GridCell>
	              <GridCell span="6">
	                <FormField className="opportunity-form-field">
	                  <TextField 
	                  	fullwidth 
	                  	label="Position" 
	                  	autoComplete="off" 
	                  	name="position" 
	                  	className='text_input' 
	                  	value={this.state.data.position} 
	                  	onChange={this.onInputChange}
	                  />
	                </FormField>
	                <FormField className="opportunity-form-field">
	                  <TextField 
	                  	type="date" 
	                  	fullwidth 
	                  	label="Cut Off Date" 
	                  	autoComplete="off" 
	                  	name="cutOffDate" 
	                  	className='text_input datepicker-padding' 
	                  	value={this.state.data.cutOffDate} 
	                  	onChange={this.onInputChange}
	                  />
	                </FormField>
	                <FormField className="opportunity-form-field">
	                  <TextField 
	                  	fullwidth 
	                  	label="Status" 
	                  	autoComplete="off" 
	                  	name="status" 
	                  	className='text_input' 
	                  	value={this.state.data.status} 
	                  	onChange={this.onInputChange}
	                  />
	                </FormField>
	              </GridCell>
	              
	              <GridCell span="6">
	              	 <Select
                     name="opportunityTypeId"
                    onChange={this.handleOpportunityTypeChange}
                    value={this.state.data.opportunityTypeId}
                    className="select-component"
                    placeholder="-- Select Type --"
                  >
                    {this.state.opportunityTypes.map(level => (
                      <option key={level.id} value={level.id} data-name={level.name}>
                        {level.name}
                      </option>
                    ))}
                  </Select>
	              </GridCell>
	              
	              <GridCell span="6">
	              	<Reactsel
										name="categories"
										onChange={this.handleChangeCategory}
										value={this.state.data.selectedCategories}
										options={this.state.opportunityCategories}
										placeholder="--Select Categories--"
										isMulti>
									</Reactsel>
	              </GridCell>

	              <GridCell span="12">
	              	<FormField className="opportunity-form-field" style={{'border-color': 'rgba(0,0,0,.42)'}}>
	              		<TextField 
	                  	fullwidth 
	                  	label="Website Link (if any)" 
	                  	autoComplete="off" 
	                  	name="websiteLink" 
	                  	className='text_input' 
	                  	value={this.state.data.websiteLink} 
	                  	onChange={this.onInputChange}
	                  />
	              	</FormField>
	              </GridCell>

	              <GridCell span="12">
	              	<FormField className="opportunity-form-field" style={{'border-color': 'rgba(0,0,0,.42)'}}>
	              		<TextField 
	                  	fullwidth 
	                  	label="Organization Image Link" 
	                  	autoComplete="off" 
	                  	name="orgImgLink" 
	                  	className='text_input' 
	                  	value={this.state.data.orgImgLink} 
	                  	onChange={this.onInputChange}
	                  />
	              	</FormField>
	              </GridCell>

	              <GridCell span="12">
	              	<FormField className="opportunity-form-field" style={{'border-color': 'rgba(0,0,0,.42)'}}>
	              		<TextField 
	                  	fullwidth 
	                  	label="Post Apply - Message" 
	                  	autoComplete="off" 
	                  	name="postApplyMsg" 
	                  	className='text_input' 
	                  	value={this.state.data.postApplyMsg} 
	                  	onChange={this.onInputChange}
	                  />
	              	</FormField>
	              </GridCell>

	              <GridCell span="4">
	              	<FormField className="opportunity-form-field" style={{'border-color': 'rgba(0,0,0,.42)'}}>
	              		<TextField 
	                  	fullwidth 
	                  	label="Listing Sequence (Number)" 
	                  	autoComplete="off" 
	                  	name="listingSequence"
	                  	className='text_input' 
	                  	value={this.state.data.listingSequence} 
	                  	onChange={this.onInputChange}
	                  />
	              	</FormField>
	              </GridCell>
	              <GridCell span="4">
	              	<FormField className="opportunity-form-field" style={{'border-color': 'rgba(0,0,0,.42)'}}>
	              		<TextField 
	                  	fullwidth 
	                  	label="Template Id for Sending Email" 
	                  	autoComplete="off" 
	                  	name="emailTemplateId"
	                  	className='text_input' 
	                  	value={this.state.data.emailTemplateId} 
	                  	onChange={this.onInputChange}
	                  />
	              	</FormField>
	              </GridCell>
	              <GridCell span="3"/>

	              <GridCell span="12">
	              	<Typography use="headline6">Job Description</Typography>
	              </GridCell>
	              
	              <GridCell span="12">
	              	<FormField className="opportunity-form-field" style={{'border-color': 'rgba(0,0,0,.42)'}}>
	                  	<Editor
	                        editorState={this.state.data.jobDescription}
	                        name = "jobDescription"
	                        wrapperClassName="demo-wrapper"
	                        editorClassName="demo-editor"
	                        onEditorStateChange={this.handleEditorDescriptionUpdate}
	                        toolbar={{
	                            options:['inline', 'list' ],
	                            link: { inDropdown: true },
	                            inline:
	                                {
	                                    options:['bold', 'italic', 'underline']
	                                },
	                        }}
	                    />
	                  <TextField 
	                  	type="hidden" 
	                  	name="opportunityId" 
	                  	value={this.state.data.opportunityId} 
	                  />
	                   <TextField 
	                  	type="hidden" 
	                  	name="active" 
	                  	value='1'
	                  />
	                </FormField>
	              </GridCell>
	              

	              <GridCell span="12" className="button-section">
	              	<Button raised theme="secondary-bg on-secondary">Save</Button>
	              	<Button raised className="cancel-button">
	              		<Link to="/portal/app/admin/opportunities" className="create-opportunity-link">
			                Cancel
			              </Link>
	              	</Button>
	              </GridCell>
	            </Grid>

	            <StatusMessage error_msg = {this.state.formErrors.organizationError}/>
	            <StatusMessage error_msg = {this.state.formErrors.positionError}/>
	            <StatusMessage error_msg = {this.state.formErrors.locationError}/>
	            <StatusMessage error_msg = {this.state.formErrors.cutOffDateError}/>
	            <StatusMessage error_msg = {this.state.formErrors.salaryError}/>
	            <StatusMessage error_msg = {this.state.formErrors.statusError}/>
	            <StatusMessage error_msg = {this.state.formErrors.jobDescriptionError}/>
	            <StatusMessage error_msg = {this.state.formErrors.opportunityTypeIdError}/>
	            <StatusMessage error_msg = {this.state.formErrors.selectedCategoriesError}/>
	            <StatusMessage error_msg = {this.state.formErrors.orgImgLinkError}/>
	            <StatusMessage error_msg = {this.state.formErrors.postApplyMsgError}/>
	            <StatusMessage error_msg = {this.state.formErrors.listingSequenceError}/>


        		</Card>
        	</form>
        </GridCell>
      </Grid>
		)
	}

}

export default OpportunityForm;


// WEBPACK FOOTER //
// ./src/views/opportunities/OpportunityForm.jsx